export default function () {
	document.addEventListener('DOMContentLoaded', () => {
		// @ts-expect-error
		const $ = jQuery;
		$('.wp-block-group.is-style-ac-accordion > p').each(function () {
			// @ts-expect-error
			$(this).append('<button><svg xmlns="http://www.w3.org/2000/svg" width="36.002" height="35.996" viewBox="0 0 36.002 35.996"><g transform="translate(0.002 -0.002)"><path d="M22285,21975h0v0h0v0Z" transform="translate(-22267 -21957)" fill="rgba(0,0,0,0)"/><path d="M22285.5,21993h-1v-17.5H22267v-1h17.5V21957h1v17.5h17.5v1h-17.5Z" transform="translate(-22267 -21957)" fill="#fff"/></g></svg></button>');
			// @ts-expect-error
			$(this).find('button')[0].addEventListener('click', () => {
				// @ts-expect-error
				$(this).next().slideToggle(300);
			});
		});
	});
}

